import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import {
  Building2,
  HardHat,
  Navigation,
  Zap,
  Brain,
  Network,
  CheckCircle2,
} from "lucide-react";
import {
  SA_PRIMARY,
  SA_SECONDARY,
  saReadableText,
  saGradientLine,
  saDarkCardBase,
  saCardBgHover,
  onDarkCardLeave,
} from "./saSectionTokens";

const ENABLEMENT_AREAS = [
  {
    icon: Building2,
    title: "Smart Cities & Urban Planning",
    color: SA_PRIMARY,
  },
  {
    icon: HardHat,
    title: "Mega Projects & Infrastructure Delivery",
    color: SA_SECONDARY,
  },
  {
    icon: Navigation,
    title: "Transportation & Mobility Networks",
    color: SA_PRIMARY,
  },
  {
    icon: Zap,
    title: "Energy, Utilities & Water Infrastructure",
    color: SA_SECONDARY,
  },
  {
    icon: Brain,
    title: "AI-Driven Asset Management & Predictive Operations",
    color: SA_PRIMARY,
  },
  {
    icon: Network,
    title: "BIM, GIS, IoT & Connected Digital Ecosystems",
    color: SA_SECONDARY,
  },
];

function SAEnablementSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;
  const heroImg = require("assets/images/shanghai-aerial-sunset.jpg");

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={10} lg={9} className="text-center">
            <h2
              className="mb-3"
              style={{
                fontSize: size ? "2.25rem" : "1.75rem",
                fontWeight: 700,
                letterSpacing: "0.06em",
                lineHeight: 1.2,
                textTransform: "uppercase",
                color: SA_PRIMARY,
                ...saReadableText,
              }}
            >
              How Digital Twins Are Enabling Transformation
            </h2>
            <div
              style={{
                width: "100px",
                height: "4px",
                borderRadius: "2px",
                margin: size ? "0 auto 2rem" : "0 auto 1.25rem",
                ...saGradientLine,
              }}
            />
          </Col>
        </Row>
        <Row className="justify-content-center mb-5">
          <Col xs={12}>
            <img
              src={heroImg}
              alt="Digital twin transformation"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "300px",
                objectFit: "cover",
                borderRadius: "16px",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
              }}
            />
          </Col>
        </Row>
        <Row>
          {ENABLEMENT_AREAS.map((item, i) => {
            const Icon = item.icon;
            const isPrimary = item.color === SA_PRIMARY;
            return (
              <Col lg={6} key={i} className="mb-4">
                <Card
                  style={{
                    ...saDarkCardBase,
                    borderRadius: "20px",
                    padding: size ? "1.75rem" : "1.35rem",
                    height: "100%",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = saCardBgHover;
                    e.currentTarget.style.borderColor = isPrimary
                      ? "rgba(54, 146, 58, 0.45)"
                      : "rgba(115, 173, 57, 0.45)";
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.boxShadow = isPrimary
                      ? "0 24px 48px rgba(54, 146, 58, 0.2)"
                      : "0 24px 48px rgba(115, 173, 57, 0.2)";
                  }}
                  onMouseLeave={onDarkCardLeave}
                >
                  <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                    <div
                      style={{
                        width: size ? 56 : 50,
                        height: size ? 56 : 50,
                        minWidth: size ? 56 : 50,
                        borderRadius: "16px",
                        background: `linear-gradient(145deg, ${item.color}33, ${item.color}14)`,
                        border: `2px solid ${item.color}55`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon size={size ? 28 : 24} strokeWidth={2} style={{ color: item.color }} />
                    </div>
                    <div className="d-flex align-items-center">
                      <CheckCircle2
                        size={16}
                        style={{ color: item.color, marginRight: "0.55rem", flexShrink: 0 }}
                        strokeWidth={2.2}
                      />
                      <h3
                        className="mb-0"
                        style={{
                          fontSize: size ? "1.05rem" : "0.95rem",
                          fontWeight: 700,
                          letterSpacing: "0.02em",
                          lineHeight: 1.35,
                          ...saReadableText,
                        }}
                      >
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default SAEnablementSection;
